import { ReactNodeViewRenderer } from "@tiptap/react"

import { BaseAttachmentNode } from "../BaseAttachment/extension"
import { ProcedureTypeAttachmentNodeComponent } from "./Component"

export const ProcedureTypeAttachmentNode = BaseAttachmentNode.extend({
	addNodeView() {
		return ReactNodeViewRenderer(ProcedureTypeAttachmentNodeComponent)
	},
})
